import { Injectable } from "@angular/core";

import { BroadcasterService as BaseBroadcasterService } from "jslib-common/services/broadcaster.service";

@Injectable()
export class BroadcasterService extends BaseBroadcasterService {}
